import ProjectBrowseListComponent from './project-browse-list.component'

const ProjectBrowseListModule = angular.module('cdbl.project-browse-list', [

])
  .component('cdblProjectBrowseList', ProjectBrowseListComponent)
  .name

export default ProjectBrowseListModule
